// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { mergeStyles } from '@fluentui/react';

/**
 * @private
 */
export const gridLayoutStyle = mergeStyles({
  width: '100%',
  height: '100%',
  display: 'grid',
  gridGap: '0.5rem'
});
